import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function OnePlusOne() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo"
          src="Images/barometer/2025/massMediaLogos/1plus1-logo.png"
          alt="partner logo"
        />
      }
      heading="Головний медіа-партнер"
    >
      <Flex direction="column" gap="5">
        <p>
          <BlueField>
            1+1 media — один з найбільших медіабізнесів Східної Європи
          </BlueField>
          &nbsp; з <br /> понад 25-річною історією. Компанія обʼєднує й
          взаємодіє на партнерських засадах з телеканалами, Digital-ресурсами,
          ОТТ-платформою та супутниковим оператором
        </p>
        <p>
          <BlueField>
            Також має власні продакшн-підрозділи, надає послуги ренталу,
            дубляжу, має свій освітній проєкт.
          </BlueField>
          &nbsp;1+1 media має широке дистрибуційне портфоліо й поширює контент
          усім світом
        </p>
        <p>
          Мета 1+1 media — втілювати в життя найсміливіші творчі ідеї, щоб
          об’єднувати вільних людей задля змін на краще
        </p>
      </Flex>
    </PartnerCard>
  );
}
